import { MouseEvent, useRef } from 'react';
import getOffset from '@framework/dom/getOffset';
import { IPopoverProps } from '@creditflowresearch/uilib/Popover';

interface IOffset {
  left: number,
  top: number,
}

export const usePopoverModifier = () => {
  const tooltipOffsetRef = useRef<IOffset>({ left: 0, top: 0 });
  const setTooltipOffset = (offset: IOffset) => {
    tooltipOffsetRef.current = offset;
  };

  const popoverOffsetOptions: IPopoverProps['offsetOptions'] = ({ rects }) => {
    const halfPopperWidth = rects.floating.width / 2;

    return {
      mainAxis: tooltipOffsetRef.current.top,
      crossAxis: tooltipOffsetRef.current.left - halfPopperWidth,
    };
  };

  const getTooltipOffset = (event: MouseEvent) => {
    const dealHeaderTarget = event.currentTarget as HTMLElement;
    const { viewportTop, viewportLeft, height, width } = getOffset(dealHeaderTarget);

    const leftOffset = event.clientX - viewportLeft - width / 2;
    const topOffset = event.clientY - viewportTop - height;

    return { left: leftOffset, top: topOffset };
  };

  return {
    popoverOffsetOptions,
    setTooltipOffset,
    getTooltipOffset,
  };
};
